<template>
  <div class="The-second-half flex al-cn">
    <img class="explore" src="@/assets/home-img/explore.png">
    <el-row :gutter="10" class="software pointer">
      <el-col :span="11" v-for="(item,index) in softwareList" :key="index">
        <div @click="skip(item.adurl)">
          <img class="img" :src="item.image">
          <div class="text">{{ item.title }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="module flex al-cn ju-sp">
      <div class="item">
        <div class="title">{{form.title}}</div>
        <div class="line"/>
        <div class="text ml25 mr25 mt10">
          {{form.brief}}
        </div>
      </div>
      <div class="item">
        <div class="title">contact us</div>
        <div class="line"/>
        <div class="button flex al-cn ju-cn" @click="$router.push({name: 'cooperation'})">view form</div>
      </div>
    </div>
  </div>
</template>

<script>
import {geticonlist, home} from "@/api/api";

export default {
  name: "The-second-half",
  data() {
    return {
      softwareList: [
       /* {
          title: 'Instagram',
          image: require('@/assets/home-img/Instagram.png'),
          adurl: 'https://www.instagram.com/me_myself_and_i_journal?igsh=cWUxNm94cHZtNDlx&utm_source=qr'
        },
        {
          title: 'spotify podcast',
          image: require('@/assets/home-img/spotify-podcast.png'),
          adurl: 'https://open.spotify.com/show/0U0VaJJIAuHxPCS3kRDCLA'
        },
        {
          title: 'tiktok',
          image: require('@/assets/home-img/tiktok.png'),
          adurl: 'https://www.tiktok.com/@me.myself.and.i.journal?_t=8qa93mtB4NB&_r=1'
        },
        {
          title: 'shopify',
          image: require('@/assets/home-img/shopify.png'),
          adurl: 'https://memyselfandijournal.myshopify.com/'
        }*/
      ],
      form:{}
    }
  },
  mounted() {
    home().then(res => {
      if(res.code === 200){
        this.form = res.data.missondata
      }
    })
    geticonlist().then(res => {
      if (res.code === 200) {
        this.softwareList = res.dydata
      }
    })
  },
  methods: {
    skip(e) {
      console.log('11111111111',e)
      if (e){
        window.open(e) //跳转
      }
    }
  }
}
</script>

<style scoped lang="scss">
.The-second-half {
  padding: 42px 43px 38px 0;
  background-color: #FFF9EB;

  .explore {
    width: 203px;
    height: 204px;
    margin: 0 45px 0 101px;
  }

  .software {
    width: 325px;
    text-align: center;

    .img {
      width: 62px;
      height: 62px;
      margin-bottom: 10px;
      margin-top: 20px;
    }

    .text {
      font-size: 17px;
      color: #262626;
      font-weight: bold;
    }
  }

  .module {
    width: 862px;

    .item {
      width: 420px;
      height: 285px;
      background-color: #F9DCBA;
      border-radius: 15px;
      color: #7B7356;

      .title {
        font-size: 29px;
        text-align: center;
        font-weight: bold;
        padding: 31px 0;
      }

      .line {
        width: 350px;
        height: 4px;
        background-color: #fff;
        margin: 0 auto
      }

      .text {
        font-size: 14px;
        text-align: center;
      }

      .button {
        width: 235px;
        height: 71px;
        background-color: #F6C796;
        text-align: center;
        border-radius: 20px;
        margin: 45px auto;
        font-size: 22px;
        font-weight: bold;

        &:hover {
          //变小手
          cursor: pointer;
          background-color: #ffcd98;
          box-shadow: 0px 0px 10px #e8b37a;
        }
      }
    }
  }

}
</style>
